import styled from 'styled-components';

import { colors } from 'styles/colors';

const textSub = colors.text['sub-500'];

export const NegativeWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const NegativeHeader = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  padding-bottom: 16px;
  border-bottom: 1px solid #FFCCCC;
`;

export const NegativeDetailsLabel = styled.div`
  font-size: 11px;
  font-weight: 600;
  color: ${colors.Grey300};
  text-transform: uppercase;
  letter-spacing: 0.06em;
`;

export const ProblemBox = styled.div`
  background: #FFF5F5;
  border: 1px solid #FFCCCC;
  border-radius: 8px;
  padding: 12px 14px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
`;

export const ProblemTitle = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: ${colors.Red};
  margin-bottom: 4px;
`;

export const ProblemBody = styled.div`
  font-size: 12px;
  color: ${textSub};
  line-height: 1.55;
`;

export const NegativeFooter = styled.div`
  font-size: 12px;
  color: ${colors.Grey300};
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 6px;
`;
